import { IRenderer } from '../renderTree.types';

export const UnderlineRenderer: IRenderer = ({ children }) => {
  if (!children) {
    return null;
  }

  return <u>{children}</u>;
};
